import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { MessageCircle } from "lucide-react";
export default function LetSDiscussYourMigrationNeeds() {
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Card className="border border-border shadow-[var(--shadow-soft)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-[var(--shadow-medium)]">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl font-bold text-foreground">
              Let's Discuss Your Migration Needs
            </CardTitle>
            <CardDescription className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground">
              Ready to migrate from Microsoft Dynamics GP to Dynamics 365 Business Central? 
              GP2BCExpress offers fast, reliable, and audit-ready migration services tailored 
              for mid-sized North American businesses. Our proven frameworks ensure precision 
              and speed, with scalable pricing starting at $7,500 CAD.
            </CardDescription>
          </CardHeader>
          <CardContent className="flex justify-center pb-8">
            <Link to="/ContactPage">
              <Button size="lg" className="group bg-primary text-white shadow-[var(--shadow-soft)] transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-[var(--shadow-medium)] active:translate-y-0 active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20">
                <MessageCircle className="transition-transform duration-[var(--duration-fast)] group-hover:rotate-12" />
                Contact Us Today
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </section>;
}